// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "f4016b8d36cf83e51d0ebafb7a8147fa" + ".js";
};